import { inheritsLoose as _inheritsLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';
import { arc } from 'd3-shape';
import { withTheme } from 'styled-components';

var _Arc;
var getIdentifierFromReactNode = function getIdentifierFromReactNode(node) {
  return typeof node === 'string' ? node : node.props.id;
};
var Arc = withTheme((// eslint-disable-next-line zillow/react/prefer-stateless-function
_Arc = /*#__PURE__*/function (_Component) {
  function Arc() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(Arc, _Component);
  var _proto = Arc.prototype;
  _proto.render = function render() {
    var props = this.props;
    var arcFn = arc().innerRadius(props.innerRadius).outerRadius(props.outerRadius).startAngle(props.startAngle).endAngle(props.endAngle);
    var radius = props.outerRadius;
    var dist = radius + 20;
    var angle = (props.startAngle + props.endAngle) / 2 + props.labelOffset;
    var x = dist * Math.sin(angle);
    var y = -dist * Math.cos(angle);
    var anchor = x > 0 ? 'start' : 'end';
    var t = "translate(" + x + "," + (y - 10) + ")";
    var tlabel = "translate(" + x + "," + (y + 10) + ")";
    var arcLabelTextStyle = {
      textAnchor: anchor,
      fill: props.theme.constellation.colors.textLight,
      shapeRendering: 'crispEdges',
      fontSize: '11px'
    };
    var arcLabelValueStyle = {
      textAnchor: anchor,
      fill: props.labelTextFill,
      shapeRendering: 'crispEdges',
      fontWeight: 'bold'
    };
    var underline;
    if (this.props.label.type && this.props.label.type.displayName === 'TooltipPopper') {
      underline = /*#__PURE__*/React.createElement("path", {
        transform: tlabel,
        d: "M -2 -16 L 23.34375 -16",
        stroke: "black",
        strokeWidth: "1",
        strokeDasharray: "1 3"
      });
    }
    return /*#__PURE__*/React.createElement("g", {
      className: "arc-group"
    }, /*#__PURE__*/React.createElement("path", {
      className: "arc",
      d: arcFn(),
      fill: props.fill
    }), !this.props.hideLabels ? /*#__PURE__*/React.createElement("g", {
      className: "arc-label-group",
      "data-key": props.dataKey
    }, typeof props.label === 'string' ? /*#__PURE__*/React.createElement("text", {
      className: "arc-label-text",
      transform: t,
      "data-label": getIdentifierFromReactNode(props.label),
      style: arcLabelTextStyle
    }, props.label) : (/*#__PURE__*/cloneElement(props.label, {
      'className': 'arc-label-text',
      'transform': t,
      'data-label': getIdentifierFromReactNode(props.label),
      'style': arcLabelTextStyle
    })), underline, /*#__PURE__*/React.createElement("text", {
      className: "arc-label-value",
      transform: tlabel,
      style: arcLabelValueStyle
    }, props.valueFormatter(props.value))) : null);
  };
  return Arc;
}(Component), _Arc.propTypes = {
  // eslint-disable-next-line zillow/react/require-default-props
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  d: PropTypes.string,
  endAngle: PropTypes.number.isRequired,
  fill: PropTypes.string,
  innerRadius: PropTypes.number.isRequired,
  label: PropTypes.node,
  labelOffset: PropTypes.number,
  labelTextFill: PropTypes.string,
  outerRadius: PropTypes.number.isRequired,
  startAngle: PropTypes.number.isRequired,
  value: PropTypes.number,
  valueFormatter: PropTypes.func,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  valueTextFill: PropTypes.string,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  dataKey: PropTypes.any,
  hideLabels: PropTypes.bool,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  theme: PropTypes.object
}, _Arc.defaultProps = {
  label: '',
  labelOffset: 0,
  fill: 'purple',
  labelTextFill: 'black',
  valueTextFill: 'white'
}, _Arc));

export { Arc as default };
